import dayjs from "dayjs";

const normalizeOptionalDate = value => {
  if (value === undefined || value === null || value === "") return undefined;

  const date = dayjs(value);
  return date.isValid() ? date.valueOf() : undefined;
};

const UNIT_DATE_FIELDS = [
  "availableDate",
  "alternateLeaseEndDate",
  "leaseStartDate",
  "leaseEndDate",
  "initialDraftDate",
  "initialPublishDate",
  "lastPublishDate",
  "updatedAt",
  "createdAt",
  "lastUnpublishDate",
  "vacantDate",
  "effectiveFromDate",
];

const normalizeDateFields = (target, fields) => {
  if (!target) return target;

  const normalizedTarget = { ...target };
  fields.forEach(field => {
    const normalizedDate = normalizeOptionalDate(target[field]);

    if (normalizedDate === undefined) delete normalizedTarget[field];
    else normalizedTarget[field] = normalizedDate;
  });
  return normalizedTarget;
};

const normalizeDraftCommentDates = draftComments =>
  draftComments?.map(comment => normalizeDateFields(comment, ["commentDate"]));

const normalizeUnitDates = unit => {
  const normalizedDates = normalizeDateFields(unit, UNIT_DATE_FIELDS);

  if (unit.leaseInfo) {
    normalizedDates.leaseInfo = normalizeDateFields(unit.leaseInfo, ["leaseStartDate", "leaseEndDate", "vacantDate"]);
  }
  if (Array.isArray(unit.draftComments)) {
    normalizedDates.draftComments = normalizeDraftCommentDates(unit.draftComments);
  }

  return normalizedDates;
};

export const normalizeBuildingPayloadDates = payload => ({
  ...payload,
  ...(Array.isArray(payload.draftComments) && {
    draftComments: normalizeDraftCommentDates(payload.draftComments),
  }),
  unitInfo: payload.unitInfo?.map(normalizeUnitDates),
});
